import {
  DialogContent,
  IconButton,
  makeStyles,
  withWidth,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import PropTypes from "prop-types";
import React from "react";
import { confirmable, createConfirmation } from "react-confirm";
import FullScreenDialog from "../../../components/FormDialog/FormDialog";
import lockImg from "../../../assets/images/ilustrator/img_konfirmasiakun.svg";
import AuthService from "../../../Services/AuthService/AuthService";
import md5 from "md5";
import { css, cx } from "emotion";
import { showWithdrawSuccessDialog } from "./WithdrawSuccessDialog";
import { handleError } from "../../../components/Utils/Utils";
import InvoiceService from "../../../Services/InvoiceService";
import { CircularProgress } from "@material-ui/core";

function ConfirmPass(props) {
  const { totalAmount, tenant, bank, orders, handleGetList, resetBillingInvoiceOrder, width, proceed } = props;
  const [openDialog, setOpenDialog] = React.useState(true);
  const [isLoading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [state, setState] = React.useState("");
  const BankAccount = {
    bank_code: tenant?.bank_code,
    bank_name: bank?.bank_name,
    bank_account_name: tenant?.bank_account_name,
    bank_account_number: tenant?.bank_account_number
  }
  const BillingInvoice = {
    tenant: tenant,
    billing_invoice_order: orders,
    bank_account: BankAccount
  }

  const handleCloseDialog = () => {
    setError(false);
    setOpenDialog(false);
    proceed();
  };

  const handleChange = (event) => {
    setState(event?.target?.value);
  };

  const handleStoreBillingInvoice = () => {
    setLoading(true)
    InvoiceService.storeInvoiceBilling(BillingInvoice)
      .then((response) => {
        setLoading(false);
        showWithdrawSuccessDialog(totalAmount, tenant, bank, handleGetList);
        resetBillingInvoiceOrder();
        handleCloseDialog();
      })
      .catch((error) => {
        setLoading(false);
        handleCloseDialog();
        handleError(error)
      })
  }

  const handleCheckPassword = () => {
    let password = md5(state);
    AuthService.checkPassword({ password })
    .then((response) => {
      if (response.status === 200) {
        setError(false)
        handleStoreBillingInvoice();
      }
    })
    .catch((error) => {
      const response = error.response;
      if (response.status === 404) {
        setError(true);
      } else {
        handleError(error)
      }
    });
  };

  return (
    <div>
      <FullScreenDialog
        disableBackdropClick
        maxWidth="md"
        fullScreen={width === "xs"}
        title={props.title}
        scroll="body"
        open={openDialog}
        HiddenCloseIcon
      >
        <DialogContent style={{ padding: "24px", minWidth: 620 }}>
          <div className="row">
            <div className="col-12">
              <div className="d-flex justify-content-end align-items-center">
                <IconButton
                  onClick={() => {
                    handleCloseDialog();
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </div>
            </div>
            <div className="col-12">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <h3
                  className={cx(
                    css`font-size; 27px !important;`,
                    "font-bold text-primary mb-4"
                  )}
                >
                  Konfirmasi Akun
                </h3>
                <img src={lockImg} alt="lock-icon" style={{ width: 108 }} />
                <span className="my-4 font-bold font-16">
                  Masukan password kamu
                </span>
                <input
                  id="password"
                  name="password"
                  type="password"
                  className={css`
                    background-color: #eeeeee !important;
                    border-radius: 4px !important;
                    width: 90% !important;
                    height: 36px !important;
                    border: none !important;
                    text-align: center !important;
                  `}
                  value={state}
                  onChange={handleChange}
                  autoFocus
                />
                {error &&
                  <span className="text-danger font-12">The password you entered is wrong</span>
                }
                <button
                  type="button"
                  className={cx(
                    css`
                      border-radius: 8px !important;
                      border: none !important;
                      background-color: #2196f3 !important;
                      color: #ffffff !important;
                      padding: 14px 32px !important;
                    `,
                    "btn text-center font-12 font-bold mt-3"
                  )}
                  onClick={() => {
                    handleCheckPassword();
                  }}
                  disabled={state === "" || isLoading}
                >
                  {isLoading && (
                    <React.Fragment>
                      <CircularProgress size="1rem" />
                      <span className="ml-2">MENGIRIM PENARIKAN DANA</span>
                    </React.Fragment>
                  )}

                  {!isLoading && "VERIFIKASI"}
                </button>
              </div>
            </div>
          </div>
        </DialogContent>
      </FullScreenDialog>
    </div>
  );
}

ConfirmPass.propTypes = {
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  cancel: PropTypes.func,
};
export function showConfirmPass(totalAmount, tenant, bank, orders, handleGetList, resetBillingInvoiceOrder, options = {}) {
  return createConfirmation(confirmable(withWidth()(ConfirmPass)))({
    totalAmount,
    tenant,
    bank,
    orders,
    handleGetList,
    resetBillingInvoiceOrder,
    ...options,
  });
}
